import { render, staticRenderFns } from "./EditorExistingComments.vue?vue&type=template&id=76fefa51&scoped=true&"
import script from "./EditorExistingComments.vue?vue&type=script&lang=js&"
export * from "./EditorExistingComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fefa51",
  null
  
)

export default component.exports